import { formatBytes } from "./FileTile";

export function SkeletonTile({ upload, tileRef, position, ready }) {
  const style = {
    position: "absolute",
    left: position?.x ?? 0,
    top: position?.y ?? 0,
    visibility: ready ? "visible" : "hidden",
    transition: "left 200ms ease, top 200ms ease",
  };

  const progress = Math.max(0, Math.min(1, upload.progress ?? 0));
  const pct = Math.round(progress * 100);
  const uploaded = Math.round(progress * (upload.size || 0));
  // Until the first progress event arrives (or for tiny files that skip
  // straight to 100%), keep the subtle shimmer so the user gets immediate
  // "yes, something is happening" feedback.
  const showShimmer = progress < 0.02;

  return (
    <div
      ref={tileRef}
      style={style}
      className="w-fit min-w-[180px] max-w-[260px] rounded-2xl bg-white/95 dark:bg-zinc-900/80 backdrop-blur-sm border border-zinc-200/70 dark:border-zinc-700/60 overflow-hidden p-3 flex flex-col gap-2 relative"
    >
      {showShimmer && (
        <div
          aria-hidden
          className="absolute inset-0 pointer-events-none animate-shimmer"
          style={{
            background:
              "linear-gradient(90deg, transparent 0%, rgba(212,212,216,0.35) 50%, transparent 100%)",
          }}
        />
      )}

      <p className="relative text-xs font-semibold text-zinc-700 dark:text-zinc-200 break-words leading-snug">
        {upload.name}
      </p>

      <div className="relative flex items-center gap-2.5">
        <span className="w-7 h-7 rounded-md bg-zinc-200 dark:bg-zinc-700 shrink-0 flex items-center justify-center">
          <span className="text-[9px] font-bold text-zinc-500 dark:text-zinc-400 tabular-nums">
            {pct}%
          </span>
        </span>
        <div className="flex-1 flex flex-col gap-1 min-w-0">
          <div className="h-1 rounded-full bg-zinc-200 dark:bg-zinc-700 overflow-hidden">
            <div
              className="h-full bg-emerald-500 transition-all duration-150"
              style={{ width: `${pct}%` }}
            />
          </div>
          <p className="text-[10px] text-zinc-500 dark:text-zinc-400 uppercase tracking-wide tabular-nums leading-tight">
            {formatBytes(uploaded)} / {formatBytes(upload.size)}
          </p>
        </div>
      </div>
    </div>
  );
}
